import {BaseLinkModel} from "../../../infrastructure/models/link/base-link-model";
import {ROUTE_NAMES} from "../../../core/consts";
import {APP} from "../../../core/app/consts";
import {CompetitorLinkParams} from "./competitor-link-params";

export class CompetitorLinkModel extends BaseLinkModel {
  constructor(competitorId: Number, sportName: String, competitorName: String, isFollow: Boolean = true) {
    super(ROUTE_NAMES.competitor, new CompetitorLinkParams(competitorId, sportName, competitorName), false, null, null);

    this.isFollow = isFollow;
    this.screen = APP.ANALYTICS.SOURCES.competitor;
  }
}